// API configuration
console.log('Environment variables:', import.meta.env);
console.log('VITE_API_URL:', import.meta.env.VITE_API_URL);
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'; 